import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

import type { Task } from '@/types/task';
import { TaskRow } from '@/components/tasks/TaskRow';

interface PrepCompletedToggleProps {
  doneTasks: Task[];
  seasonId: string;
  onToggleComplete: (task: Task) => void;
}

export function PrepCompletedToggle({
  doneTasks,
  seasonId,
  onToggleComplete,
}: PrepCompletedToggleProps) {
  const [expanded, setExpanded] = useState(false);

  if (doneTasks.length === 0) return null;

  const label = expanded
    ? `HIDE ${doneTasks.length} COMPLETED`
    : `SHOW ${doneTasks.length} COMPLETED`;

  return (
    <div data-testid="prep-completed-toggle">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between text-[var(--color-text-muted)] border-t-[0.5px] border-dashed border-[var(--color-border)] bg-transparent"
        style={{ padding: '18px 16px 22px' }}
        data-testid="prep-completed-toggle-button"
        aria-expanded={expanded}
      >
        <span className="field-label">{label}</span>
        <ChevronDown
          size={10}
          aria-hidden="true"
          data-expanded={expanded ? 'true' : 'false'}
          className="text-[var(--color-text-muted)] transition-transform motion-reduce:transition-none"
          style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transitionDuration: 'var(--duration-180)' }}
        />
      </button>

      {expanded && (
        <div data-testid="prep-completed-list">
          {doneTasks.map((task) => (
            <TaskRow
              key={task.id}
              task={task}
              seasonId={seasonId}
              onToggleComplete={onToggleComplete}
              showStrikethrough={false}
            />
          ))}
        </div>
      )}
    </div>
  );
}
